import $ from "cash-dom";
import { goToFlow } from "./flowTargets.js";

$(function () {
  $(document).on("click", "[data-report-flow]", function () {
    goToFlow($(this).attr("data-report-flow"), {
      company: $(this).attr("data-report-company"),
      position: $(this).attr("data-report-position"),
    });
  });
});
